<template><div><h1 id="eloqua-publikationen-zuordnung" tabindex="-1"><a class="header-anchor" href="#eloqua-publikationen-zuordnung"><span>Eloqua Publikationen Zuordnung</span></a></h1>
<p>Eloqua Publikationen Zuordnung — Zuordnung der Publikationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle wird die Zuordnung der Publikationen zwischen Eloqua und funtrade definiert. Die Zuordnung wird nur benötigt falls der entsprechende Wert in beiden Systemen unterschiedlich definiert ist.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Eloqua → Eloqua Publikationen Zuordnung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Feldwert</dt>
<dd>In Eloqua definierter Wert.</dd>
<dt>Publikation</dt>
<dd>In funtrade definierter Wert in der Tabelle Publikationen.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/eloqua.html" title="3. Eloqua (Marketing Automation)">Eloqua</RouteLink></p>
</div></template>


